import { isNotInRange } from "../../utils/customFunctions";

export const validateMemberData = ({
	firstName,
	type,
	days,
	password,
	email,
	phone,
	subscriptionType,
	create = false,
}) => {
	const errors = {};
	if (!firstName) {
		errors.firstName = "First name is required";
	} else if (isNotInRange({ min: 3, max: 40, str: firstName })) {
		errors.firstName = {
			message: "First name must be between 3 and 40 characters",
			args: { min: 3, max: 40 },
		};
	}

	if (subscriptionType !== "FREEMIUM") {
        const isEmpty = days === undefined || days === null || days === "";
        if (isEmpty) {
            if (create) errors.days = "Please enter the number of days";
        } else {
            const daysNum = parseInt(days);
            if (isNaN(daysNum) || daysNum < 1) {
                errors.days = "Subscription days must be at least 1";
            }
        }
    }

	if (create && !password && type === "email") {
		errors.password = "Passowrd is Required!";
	}
	if (
		create &&
		password &&
		isNotInRange({ min: 8, max: 50, str: password }) &&
		type === "email"
	) {
		errors.password = {
			message: "Password must be between 8 and 50 characters",
			args: { min: 8, max: 50 },
		};
	}

	if (create && !email && type === "email") {
		errors.email = {
			message: "Email address is required",
			args: { field: "Email" },
		};
	}

	if (
		create &&
		email &&
		isNotInRange({ min: 5, max: 50, str: email }) &&
		type === "email"
	) {
		errors.email = {
			message: "Email must be between 5 and 50 characters",
			args: { min: 10, max: 50 },
		};
	}

	if (create && !phone && type === "phone") {
		errors.phone = {
			message: "Phone number is required",
			args: { field: "Phone" },
		};
	}

	if (
		create &&
		phone &&
		isNotInRange({ min: 6, max: 50, str: phone }) &&
		type === "phone"
	) {
		errors.phone = {
			message: "Phone number must be between 6 and 50 characters",
			args: { min: 10, max: 50 },
		};
	}

	return errors;
};
